export default "__VITE_ASSET__DYOKcQMP__"